'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@/lib/ui/utils';
export type SidebarSectionId = 'explore' | 'watchlists' | 'settings' | 'resources' | 'account';
export interface SidebarSectionProps {
  id: SidebarSectionId;
  title: string;
  children: ReactNode;
  className?: string;
}
export function SidebarSection(t0) {
  const $ = _c(11);
  const {
    id,
    title,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h2 className="px-3 text-caption font-medium uppercase tracking-wide text-foreground-tertiary">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <ul className="flex flex-col">{children}</ul>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== id || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <section data-section={id} className={t1}>{t2}{t3}</section>;
    $[6] = id;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}